module.exports = __webpack_public_path__ + "img/icn_VR@3x.1075b852.png";